import './sms-send.less';
import React from 'react';
import {withRouter} from 'react-router-dom';
import {Button, Form, Radio} from 'antd';
import {inject, observer} from 'mobx-react';
import {isValidSite, Site, SitesList} from '../../../../models/site';
import {SelectPhone} from '../../../common/select-phones';
import TextArea from 'antd/lib/input/TextArea';
import {toJS} from 'mobx';

@withRouter
@inject('sendSmsStore')
@observer
export class SmsSend extends React.Component {

  componentWillMount() {
    const query = new URLSearchParams(this.props.location.search);

    let phones = [], site = Site.RusPropusk;
    if (query.has('phones')) {
      phones = query.get('phones').split(',');
    }

    if (isValidSite(query.get('site'))) {
      site = query.get('site');
    }

    this.props.sendSmsStore.initialize(phones, site);
  }

  render() {
    const { sendSmsStore } = this.props;
    const form = toJS(sendSmsStore.form);

    const { isSending, isPhonesReadonly, validations, formMessageInfo } = sendSmsStore;

    return (
      <div className="send-sms">
        <h1>Отправка смс</h1>

        <div className="form-group">
          <label>Отправитель</label>
          <Radio.Group value={form.site} onChange={(e) => sendSmsStore.patchForm({ site: e.target.value })}>
            {SitesList.map(site => (
              <Radio key={site.key} style={ { display: 'block', height: '30px', lineHeight: '30px'}} value={site.key}>
                {site.name}
              </Radio>
            ))}
          </Radio.Group>
        </div>

        <div className="form-group">
          <label>Сообщение</label>

          <Form.Item
            validateStatus={validations.message}
            help={validations.message === 'error' && 'Сообщение обязательно для отправки'}
          >
            <TextArea
              autosize
              style={{ minHeight: 200 }}
              value={form.message}
              onChange={e => sendSmsStore.patchForm({ message: e.target.value })} />
          </Form.Item>

          {form.message && (
            <div className="message-input-symbols-info">
              Количество символов: {formMessageInfo.current}/{formMessageInfo.maxSymbols} символа ({formMessageInfo.countSms} СМС)
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Список номеров</label>
          <Form.Item
            validateStatus={validations.phones}>
            {isPhonesReadonly && <div className="readonly-phones">{form.phones.map(phone => <div key={`readonly-phone-${phone}`}>{phone}</div>)}</div>}
            {!isPhonesReadonly && <SelectPhone phones={form.phones} onChange={phones => sendSmsStore.patchForm({ phones })} />}
          </Form.Item>
        </div>

        <div className="form-group">
          <Button type="primary"
                  loading={isSending}
                  onClick={() => sendSmsStore.send()} size={'large'}>Отправить</Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/crm/sms/sms-send.js